import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxEchartsModule} from 'ngx-echarts';
import {DmpChartComponent} from './dmp-chart.component';
import {echarts} from './echarts-core';

@NgModule({
    declarations: [DmpChartComponent],
    imports: [
        CommonModule,
        NgxEchartsModule.forRoot({ echarts })
    ],
    exports: [
        DmpChartComponent,
        NgxEchartsModule
    ]
})
export class EchartsModule {
}
